module.exports = __webpack_public_path__ + "static/client-4-fd2c521837cde5131f6926ee2be8b57b.jpg";